import { PREORDER_STATUS_DISPLAY_LABEL, PreorderExternalStatus } from '@ekhodealer/ekho-common';
import { Tag } from '@ekhodealer/ekho-common/rev';

/**
 * Map preorder status to Tag accent color
 */
const getStatusAccent = (status: string | undefined): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!status) return 'neutral';

	switch (status) {
		case PREORDER_STATUS_DISPLAY_LABEL[PreorderExternalStatus.PENDING_INVITATION]:
			return 6; // Yellow
		case PREORDER_STATUS_DISPLAY_LABEL[PreorderExternalStatus.AWAITING_CHECKOUT]:
			return 2; // Blue
		case PREORDER_STATUS_DISPLAY_LABEL[PreorderExternalStatus.IDLE]:
			return 'neutral';
		case PREORDER_STATUS_DISPLAY_LABEL[PreorderExternalStatus.CONVERTED]:
			return 7; // Green
		case PREORDER_STATUS_DISPLAY_LABEL[PreorderExternalStatus.CANCELED]:
			return 4; // Red
		default:
			return 'neutral';
	}
};

interface StatusCellProps {
	/** The preorder status value */
	status: string | undefined;
}

export const StatusCell = ({ status }: StatusCellProps) => {
	const displayText = status ?? '\u2014';
	const accent = getStatusAccent(status);

	return <Tag size='medium' accent={accent}>{displayText}</Tag>;
};
